// University of Washington's undergraduate majors (#2743). Read on 2026-10-01
// from the UW Office of Admissions majors list (admit.washington.edu/academics/
// majors/), which tags each Seattle major with the college or school that
// offers it: all 118 entries kept. The list names no degree type except in
// some music names ("Guitar, B.M.", "Music, B.A."), which are split into the
// degree field; every other degree is null rather than guessed (the major
// pages' "curricular options" mix degrees with concentrations). Two names
// carry an en dash on the list ("English \u2013 Creative Writing", "Public
// Health \u2013 Global Health"); a colon replaces it here. One major, Public
// Service & Policy, carries no college tag on the list; it is grouped under
// the Evans School, whose own page offers it. The direct-admission flags and
// the engineering note quote UW's Admission to majors page (the college
// file's `majorsAdmit` source). The KB's majors list was the starting point;
// the official list wins.
const majors = {
    "slug": "university-of-washington",
    "read": "2026-10-01",
    "intro": "Every undergraduate major on the UW Office of Admissions majors list for the Seattle campus, grouped by the college or school that offers it. The list names a degree only for some music majors; the rest are left blank. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "American Ethnic Studies",
                    "degree": null
                },
                {
                    "name": "American Indian Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Applied & Computational Mathematical Sciences (ACMS)",
                    "degree": null
                },
                {
                    "name": "Applied Mathematics",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Asian Languages & Cultures",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Astronomy",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Cinema & Media Studies",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Comparative History of Ideas (CHID)",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Comparative Religion",
                    "degree": null
                },
                {
                    "name": "Computational Finance & Risk Management",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Danish",
                    "degree": null
                },
                {
                    "name": "Design",
                    "degree": null
                },
                {
                    "name": "Disability Studies",
                    "degree": null
                },
                {
                    "name": "Drama",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English: Creative Writing",
                    "degree": null
                },
                {
                    "name": "English: Language, Literature & Culture",
                    "degree": null
                },
                {
                    "name": "Ethnomusicology",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": null
                },
                {
                    "name": "Finnish",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Gender, Women & Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Global Literary Studies",
                    "degree": null
                },
                {
                    "name": "Greek",
                    "degree": null
                },
                {
                    "name": "Guitar",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History & Philosophy of Science",
                    "degree": null
                },
                {
                    "name": "Individualized Studies",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Jazz Studies",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Korean",
                    "degree": null
                },
                {
                    "name": "Latin",
                    "degree": null
                },
                {
                    "name": "Latin American & Caribbean Studies",
                    "degree": null
                },
                {
                    "name": "Law, Societies & Justice",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Middle Eastern Languages & Cultures",
                    "degree": null
                },
                {
                    "name": "Music Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Norwegian",
                    "degree": null
                },
                {
                    "name": "Orchestral Instruments",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Organ",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Percussion Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Piano",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Scandinavian Area Studies",
                    "degree": null
                },
                {
                    "name": "Slavic Languages & Literatures",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "South Asian Languages & Cultures",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Speech & Hearing Sciences",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Strings",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Swedish",
                    "degree": null
                },
                {
                    "name": "Voice",
                    "degree": "B.M.",
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                }
            ]
        },
        {
            "name": "College of Built Environments",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Architectural Design",
                    "degree": null
                },
                {
                    "name": "Architectural Studies",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Community, Environment & Planning",
                    "degree": null
                },
                {
                    "name": "Construction Management",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Environmental Design & Sustainability",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Real Estate",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Early Childhood & Family Studies",
                    "degree": null
                },
                {
                    "name": "Education Studies",
                    "degree": null
                },
                {
                    "name": "Education, Communities & Organizations",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Aeronautics & Astronautics",
                    "degree": null
                },
                {
                    "name": "Bioengineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Electrical & Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Human Centered Design and Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial Engineering",
                    "degree": null
                },
                {
                    "name": "Materials Science & Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                }
            ],
            "note": "Every College of Engineering major admits first-year students Direct to College: list any engineering major first, and if admitted you start as engineering undeclared before placement in a major.",
            "noteSource": "majorsAdmit"
        },
        {
            "name": "College of the Environment",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Aquatic Conservation & Ecology",
                    "degree": null
                },
                {
                    "name": "Atmospheric and Climate Science",
                    "degree": null
                },
                {
                    "name": "Earth & Space Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Science & Terrestrial Resource Management",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Marine Biology",
                    "degree": null
                },
                {
                    "name": "Oceanography",
                    "degree": null
                },
                {
                    "name": "Sustainable Bioresource Systems Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "Michael G. Foster School of Business",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                }
            ]
        },
        {
            "name": "Paul G. Allen School of Computer Science & Engineering",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Computer Engineering",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                },
                {
                    "name": "Computer Science",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                }
            ]
        },
        {
            "name": "The Information School",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Informatics",
                    "degree": null,
                    "flag": "Admits some students directly as first-years; list it as your first-choice major on the application.",
                    "flagSource": "majorsAdmit"
                }
            ]
        },
        {
            "name": "School of Medicine",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Medical Laboratory Science",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Environmental Public Health",
                    "degree": null
                },
                {
                    "name": "Food Systems, Nutrition, & Health",
                    "degree": null
                },
                {
                    "name": "Public Health: Global Health",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "UW Office of Admissions, Majors",
                "url": "https://admit.washington.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Social Welfare",
                    "degree": null
                }
            ]
        },
        {
            "name": "Evans School of Public Policy & Governance",
            "source": {
                "label": "UW Evans School, Public Service and Policy Major",
                "url": "https://evans.uw.edu/programs/public-service-policy-major/"
            },
            "majors": [
                {
                    "name": "Public Service & Policy",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
